import qs from 'qs';

export default {
    baseURL:
        window.VITE_PUBLIC_API_URL ||
        (import.meta.env.DEV ? '' : import.meta.env.VITE_PUBLIC_API_URL),
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' }),
    timeout: 60 * 1000,
};
